import { createStore } from 'vuex'
import utente from "./modules/utente.module";
import siti from "./modules/siti.module";
import esiti from "./modules/esiti.module";
import articoli from "./modules/articoli.module";
import magazzini from "./modules/magazzini.module";
import entita from "./modules/entita.module";
import unita from "./modules/unita.module";
import reparti from "./modules/reparti.module"
import statiIntervento from "./modules/statiIntervento.module";
import contratti from "./modules/contratti.module";
import statiContratti from "./modules/statiContratto.module";

export default createStore({  
  modules: {
    utente,
    siti,
    esiti,
    articoli,
    magazzini,
    entita,
    unita,
    reparti,
    statiIntervento,
    contratti,
    statiContratti
  }
})
